import { clsx } from 'clsx'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import useMobileDetect from 'use-mobile-detect-hook'

import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { List } from '@tribeplatform/react-ui-kit/Layout'

import { T } from '../../i18n/index.js'
import { useQuerySmartSearch } from '../index.js'
import { ResultsView, SmartSearchEntityType } from '../SmartSearch.types.js'

import { SmartSearchResultsSection } from './SmartSearchResults/SmartSearchResultsSection.js'

type Props = {
  query: string
  view?: ResultsView
  onSwitchToResults: (type: SmartSearchEntityType) => void
}

export const AskAISources = ({
  query,
  view = 'command-bar',
  onSwitchToResults,
}: Props) => {
  const { isMobile } = useMobileDetect()
  const { postsQuery, spacesQuery, hasResultsByType } = useQuerySmartSearch({
    query,
  })

  const hasResults =
    hasResultsByType(SmartSearchEntityType.OFFICIAL_POSTS) ||
    hasResultsByType(SmartSearchEntityType.POSTS) ||
    hasResultsByType(SmartSearchEntityType.SPACES)

  if (!hasResults) {
    return null
  }

  const titleClassName = view === 'search-page' ? 'text-heading-2xs' : ''

  const sectionTitleClassName = clsx(titleClassName, 'px-4 lg:px-5 py-2')

  const items = [
    {
      type: SmartSearchEntityType.POSTS,
      queryResult: postsQuery,
    },
    {
      type: SmartSearchEntityType.SPACES,
      queryResult: spacesQuery,
    },
  ]

  const handleSwitchToSolely = (type: SmartSearchEntityType) => {
    // if the user is on mobile, we need to switch to solely type
    if (view === 'command-bar' && isMobile()) {
      onSwitchToResults(type)
    }
  }

  return (
    <div className="flex flex-col flex-1 gap-1 py-3">
      <div
        className={`flex gap-2 items-center pt-1 px-4 lg:px-5 font-semibold ${titleClassName}`}
      >
        <SvgIcon name="layers-three" size="lg" />
        <T
          id="SmartSearch.AskAI.SearchResultSources"
          defaultMessage="Search result sources"
        />
      </div>

      <List
        className="divide-y divide-line-subdued flex flex-col gap-2"
        spacing="none"
      >
        {items.map(item => (
          <SmartSearchResultsSection
            key={item.type}
            type={item.type}
            queryResult={item.queryResult}
            query={query}
            view={view}
            titleClassName={sectionTitleClassName}
            onSwitchToSolely={handleSwitchToSolely}
          />
        ))}
      </List>
    </div>
  )
}
